import React from 'react';
import PropTypes from 'prop-types';

import Email from 'src/components/OligoDNA/components/Email';
import Summary from 'src/components/OligoDNA/components/Summary';

const ReviewAndAddToCart = ({
  onFileDetailsEdit,
  onPlateSizeDetailsEdit,
  onNormalizationAliquotsDetailsEdit,
  onPlatePoolingDetailsEdit,
}) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="review-page-container">
      <Email />
      <Summary
        {...{
          showTitle: true,
          showOrderSummaryTitle: true,
          onFileDetailsEdit,
          onPlateSizeDetailsEdit,
          onNormalizationAliquotsDetailsEdit,
          onPlatePoolingDetailsEdit,
        }}
      />
    </div>
  );
};

ReviewAndAddToCart.propTypes = {
  onFileDetailsEdit: PropTypes.func.isRequired,
  onPlateSizeDetailsEdit: PropTypes.func.isRequired,
  onNormalizationAliquotsDetailsEdit: PropTypes.func.isRequired,
  onPlatePoolingDetailsEdit: PropTypes.func.isRequired,
};

export default ReviewAndAddToCart;
